import { Store } from "@/zustand/store";
import { StateCreator } from "zustand";
import { Notification } from "../types";

export type NotificationsSlice = {
  notifications: Notification[];
  setNotifications: (notifications: Notification[]) => void;
};

const initialData = {
  notifications: [],
};

export const updateNotificationsSlice: StateCreator<
  Store,
  [],
  [],
  NotificationsSlice
> = (set) => ({
  ...initialData,
  setNotifications: (notifications) => set({ notifications }),
});
